// S14 — The BE now writes audit log entries directly from every mutating
// controller (vehicle.create, article.publish, lead.update, vb.). The FE
// `recordAuditAction` therefore becomes a no-op; we keep the function so the
// dozens of legacy call sites still compile without a sweeping migration.

import type { AuditAction, AuditResource } from './types';

interface RecordInput {
  action: AuditAction;
  resource: AuditResource;
  resourceId?: string;
  summary: string;
  meta?: Record<string, unknown>;
}

 
export async function recordAuditAction(_input: RecordInput): Promise<void> {
  // intentionally empty — BE emits audit log entries server-side.
}
